<ng-template cdk-connected-overlay [cdkConnectedOverlayHasBackdrop]="false"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop" [cdkConnectedOverlayOrigin]="overlayOrigin"
  [cdkConnectedOverlayFlexibleDimensions]="flexibleDimensions" [cdkConnectedOverlayOpen]="show"
  [cdkConnectedOverlayPositions]="overlayPositions" [cdkConnectedOverlayPush]="pushToViewport"
  [cdkConnectedOverlayViewportMargin]="pushToViewport ? 8 : 0"
  [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
  (detach)="dismissCallout()">
  <div class="callout" [ngClass]="{'callout-left' : position === 'left', 'callout-bottom':position === 'bottom',
    'callout-top': position === 'top', 'callout-right': position === 'right',  'callout-top-right': position === 'top-right',
    'callout-top-center': position === 'top-center',
    'hidden-callout':hidden, 'hide-for-small-screens': hideForSmallScreens }"
    [class]="panelClass">
    <p class="callout-title">
      {{ title }}
    </p>
    <p class="callout-description">
      {{ description }}
    </p>

    <div class="callout-buttons-container">
      <!-- CTA Button -->
      <ng-container *ngIf="ctaButtonLabel && ctaButtonAction">
        <button class="callout-cta-btn"
            (click)="handleCtaClick()">
          {{ ctaButtonLabel }}
        </button>
      </ng-container>

       <!-- Dismiss Button -->
       <ng-container *ngIf="dismissButtonLabel">
        <button class="callout-dismiss-btn"
            (click)="dismissCallout()">
          {{ dismissButtonLabel }}
        </button>
      </ng-container>
    </div>
  </div>
</ng-template>
